"use strict";

exports.__esModule = true;
exports.MetricMTCDataTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _widgetGroups = require("../widgetGroups");
var _MTCDataTable = require("../MTCDataTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var MetricMTCDataTableWidget = exports.MetricMTCDataTableWidget = {
  name: "MetricMTCDataTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "MetricMTCDataTableWidget.label",
    defaultMessage: "MTC Metric Table"
  }),
  icon: "th-list",
  group: _widgetGroups.RAW_DATA_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "MetricMTCDataTable",
      props: Object.assign({
        width: 512,
        height: 512
      }, props, {
        pageSizes: [25, 50, 100, 250]
      }),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: ["device"],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "backgroundColor", "backgroundColorSource", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 256,
      min: 32,
      max: 1024
    },
    height: {
      "default": 64,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)((0, _MTCDataTable.MTCDataTableElementClosure)({
      dataSource: "metricMTC"
    })),
    Fields: (0, _MTCDataTable.MTCDataTableFieldsClosure)({
      dataSource: "metricMTC"
    }),
    Thumbnail: _MTCDataTable.MTCDataTableThumbnail
  }
};